import addAdmissionGroupPanelCtrl from 'panels/addAdmissionGroup/controller';
import addAdmissionGroupPaymentRequestsPanelCtrl from 'panels/addAdmissionGroupPaymentRequests/controller';
import addAdmissionGroupReceiptsPanelCtrl from 'panels/addAdmissionGroupReceipts/controller';
import addAttributionSourcePanelCtrl from 'panels/addAttributionSource/controller';
import addInternalNotePanelCtrl from 'panels/addInternalNote/controller';
import admissionGroupCheckinPanelCtrl from 'panels/admissionGroupCheckIn/controller';
import cancelAdmissionGroupPanelCtrl from 'panels/cancelAdmissionGroup/controller';
import addInventoryCtrl from 'panels/addInventory/controller';
import addIntegrationCtrl from 'panels/addIntegration/controller';

function init(app) {
  if (!app) throw new Error('app is required');

  app.controller('addAdmissionGroupPanelCtrl', addAdmissionGroupPanelCtrl);
  app.controller('addAdmissionGroupPaymentRequestsPanelCtrl', addAdmissionGroupPaymentRequestsPanelCtrl);
  app.controller('addAdmissionGroupReceiptsPanelCtrl', addAdmissionGroupReceiptsPanelCtrl);
  app.controller('addAttributionSourcePanelCtrl', addAttributionSourcePanelCtrl);
  app.controller('addInternalNotePanelCtrl', addInternalNotePanelCtrl);
  app.controller('admissionGroupCheckinPanelCtrl', admissionGroupCheckinPanelCtrl);
  app.controller('cancelAdmissionGroupPanelCtrl', cancelAdmissionGroupPanelCtrl);
  app.controller('addInventoryPanelCtrl', addInventoryCtrl);
  app.controller('addIntegrationPanelCtrl', addIntegrationCtrl);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/panels/index.js